<template>
  <router-view />
</template>

<script>
export default {
  data () {
    return {
      sidebar: [
        {
          icon: ['fal', 'calendar-alt'],
          route: { name: 'manage-accounts-account-pickups-scheduled', params: { accountId: this.$route.params.accountId } },
          name: 'Scheduled Pickups'
        }
      ],
      breadcrumb: {
        name: 'Pickups',
        route: { name: 'manage-accounts-account-pickups', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>

<style>

</style>
